import React, { Component } from "react";
import { connect } from "react-redux";
import {
    NavItem,
    NavLink
} from "reactstrap";
import Popover from "@material-ui/core/Popover";
import { formHelper } from "../../../../../areas/form/helpers/formHelper";
import LaunchIcon from '@material-ui/icons/Launch';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import SystemLabel from "../../../../../../system/SystemLabel/SystemLabel";
import Zoom from '@material-ui/core/Zoom';
import { Tooltip } from '@material-ui/core';
import { labelHelper } from "../../../../../../helpers/labelHelper";
const RunFormOption = (props) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [warningMessage, setWarning] = React.useState('');
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };
    const runForm = (e) => {
        const { form } = props;
        const { result, message } = formHelper.isPublishable(form.formElements);

        if (!result && !form.survey) {
            setAnchorEl(e.currentTarget);
            setWarning(message)
            return;
        }
        let path = form.survey ? "survey" : "register";
        if (window.location.href.includes("localhost")) {
            window.open(`/${path}/${form.formId.toString(36)}`);
        }
        else {
            window.open(`/cms/${path}/${form.formId.toString(36)}`);
        }
    }
    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;
    return (
        <React.Fragment>
            <NavItem>
                <Tooltip TransitionComponent={Zoom} placement="top" title={labelHelper.getLabel("RunForm")}>
                    <NavLink className="nav-toolbar-item" style={{ cursor: 'pointer' }} >
                        <LaunchIcon className="editor-toolbar-icon" style={{ fontSize: '18px !important', color: open ? '#fff' : 'inital', marginBottom: '2px' }} onClick={(e) => runForm(e)} />
                    </NavLink>
                </Tooltip>
                <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    style={{ zIndex: 10000, padding: "10px" }}
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "center"
                    }}
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "center"
                    }}
                >
                    <ul style={{ paddingTop: "1rem", padding: '10px', margin: '0px' }}>
                        {warningMessage &&
                            warningMessage.map((m, i) => {
                                return (
                                    <li key={i} style={{ display: 'flex', margin: '5px 0px' }}>
                                        <ErrorOutlineIcon style={{ marginRight: '5px' }} />
                                        <SystemLabel name={m} />
                                    </li>
                                );
                            })}
                    </ul>
                </Popover>
            </NavItem>
        </React.Fragment>
    );
};

function mapStateToProps(state) {
    return {
        form: state.form
    };
}
export default connect(mapStateToProps)(RunFormOption);
